module.exports = __webpack_public_path__ + "static/mujer-fc4ca268319181a8d32f60871b5ac404.jpg";